module.exports = __webpack_public_path__ + "static/img/10-4.dfbfe20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10-4.png
// module id = TukW
// module chunks = 1